import { memo } from 'react'
import { Box, Button, Divider, Typography } from '@mui/material'
import ChevronRightIcon from '@mui/icons-material/ChevronRight'
import { makeStyles } from 'tss-react/mui'

const useStyles = makeStyles()((theme) => ({
    stickyHeader: {
        zIndex: 99
    },
    headerLabel: {
        padding: '8px 16px',
        fontSize: '14px',
        fontWeight: 500,
        textTransform: 'uppercase',
        background: theme.palette.background.paper
    },
    moreButton: {
        marginTop: theme.spacing(1.5),
        textTransform: 'none',
        fontSize: '13px',
        fontWeight: 500,
        justifyContent: 'space-between',
        minHeight: 32,
    },
}))

export type OverviewSectionHeaderProps = {
    title: string
    id?: string
    onClick?: () => void
    sticky?: boolean
}

const OverviewSectionHeader = ({ title, id, onClick, sticky = false }: OverviewSectionHeaderProps) => {
    const { classes, cx } = useStyles()

    return (
        <Box onClick={onClick} className={sticky ? cx(classes.stickyHeader, 'sticky') : undefined}>
            <Divider />
            <Typography id={id} className={classes.headerLabel}>
                {title}
            </Typography>
        </Box>
    )
}

export type OverviewMoreButtonProps = {
    label: string
    onClick: () => void
    eventName?: string
}

export const OverviewMoreButton = memo(function OverviewMoreButton({
    label,
    onClick,
    eventName,
}: OverviewMoreButtonProps) {
    const { classes } = useStyles()

    return (
        <Button
            fullWidth
            variant="outlined"
            color="inherit"
            size="small"
            className={classes.moreButton}
            endIcon={<ChevronRightIcon fontSize="small" />}
            onClick={onClick}
            data-event={eventName}
        >
            {label}
        </Button>
    )
})

export default memo(OverviewSectionHeader)
